module.exports = __webpack_public_path__ + "static/img/wx_real_name_banner.82d7cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/wx_real_name_banner.png
// module id = MGY1
// module chunks = 216